import { render, staticRenderFns } from "./customComponentEdit.vue?vue&type=template&id=592b3242&scoped=true"
import script from "./customComponentEdit.vue?vue&type=script&lang=js"
export * from "./customComponentEdit.vue?vue&type=script&lang=js"
import style0 from "./customComponentEdit.vue?vue&type=style&index=0&id=592b3242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592b3242",
  null
  
)

export default component.exports